import {EnrollTrackRole} from 'Users/models/User/EnrollmentTrackingUserType';

export class EtsEnrollmentOperationsUserType {
  public readonly key = 'EtsEnrollmentOperationsUserType';
  public readonly enrollTrackRole = EnrollTrackRole.EtsEnrollmentOperations;
}
